import { gsap, random } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

gsap.set(".nav-phone-number-appearance", { opacity: 0, y: -40 });

ScrollTrigger.create({
  trigger: "body",
  start: "10% top",      // fires when 40% of the page has scrolled past the top
  onEnter: () => {
    gsap.to(".nav-phone-number-appearance", {
      opacity: 1,
      visibility: "visible",
      y: 0,
      pointerEvents: "auto",
      duration: 0.8,
      ease: "power2.out",
    });
  },
  onLeaveBack: () => {
    gsap.to(".nav-phone-number-appearance", {
        opacity: 0,
        visibility: "hidden",
        pointerEvents: "none",
        y: -40,
        duration: 0.4
    });
  },
});